import { create } from 'zustand'

interface SidebarStore {
  isOpen: boolean
  isCollapsed: boolean
  toggle: () => void
  setCollapsed: (v: boolean) => void
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  isOpen: false,
  isCollapsed: false,
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  setCollapsed: (v) => set({ isCollapsed: v }),
}))
